import { Component, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { App, NavController, NavParams, ToastController, Events } from 'ionic-angular';
import { ResultProvider, ResultListModel } from '../../../../providers/result/result';
import { UserProvider, PrivateProfile, PublicProfileModel } from '../../../../providers/user/user';
import { LoaderProvider } from '../../../../providers/loader/loader';
import { EventTabsPage } from '../../../event/details/event-tabs/event-tabs';
import { EventDetailsModel, EventProvider } from '../../../../providers/event/event';
import { ResultProfilePage } from '../../result-profile/result-profile';
import { ValueProvider } from '../../../../providers/value/value';
import { SessionProvider } from '../../../../providers/session/session';
import { LoginPage } from '../../../login/login/login';
import { ThemeMode } from '../../../../providers/dark-mode/dark-mode';
import { AppDetectorProvider } from '../../../../providers/detector/detector';

@Component({
    selector: 'page-result-details-thumbup',
    templateUrl: 'result-details-thumbup.html'
})
export class ResultDetailsThumbupPage {
    state = "gray";
    result: ResultListModel;
    profile: PrivateProfile;
    fans: any;

    pager: { page: any, start: any, limit: any } = { page: null, start: null, limit: null };


    themeMode
    constructor(
        public navCtrl: NavController,
        public navParams: NavParams,
        public app: App,
        public translate: TranslateService,
        private resultProvider: ResultProvider,
        private toastCtrl: ToastController,
        private userProvider: UserProvider,
        private loadingCtrl: LoaderProvider,
        private valueService: ValueProvider,
        private userService: UserProvider,
        private sessionService: SessionProvider,
        private eventService: EventProvider,
        private eventsListener: Events,
        private appDetector: AppDetectorProvider
    ) { }
    ngOnInit(){
        this.themeMode =  JSON.parse(localStorage.getItem('darkMode') || `"${ThemeMode.LightMode}"`) as ThemeMode;
        this.themeMode==="darkMode"? this.state = "white" : this.state = "gray"
    }

    onToogleDOM() {
        if(this.themeMode==="darkMode"){
            if(this.appDetector.isForestApp()){
                this.state = (this.state == "white") ? "#71af4b" : "white";  
            }
            if(this.appDetector.isLeaderBoardApp()){
                this.state = (this.state == "white") ? "#4285F4" : "white";
            }
            
        }else{
            this.state = (this.state == "gray") ? "#294F94" : "gray";  
        }
        
        let span = document.getElementById('span-text');
        let likeImgs = document.getElementsByName('md-thumbs-up')
        likeImgs.forEach(img=>{
            img.style.color = this.state
        })
        span.style.color = this.state;
    }

    onToogleFan() {
        (this.state == "white" || this.state == "gray") ? this.addFan() : this.removeFan();  
    }

    isOwner(id) {
        if (this.profile) return (this.profile.id == id) ? true : false;
    }

    addFan() {
        if (!this.sessionService.isLoged) {
            this.navCtrl.push(LoginPage, { isRootNav: false });
            return;
        }

        this.resultProvider.congrat(this.result.id).then(() => {
            this.getFans();
            this.onToogleDOM();
            this.eventsListener.publish('toolbar:update');
        });
    }

    removeFan() {
        if (!this.sessionService.isLoged) {
            this.navCtrl.push(LoginPage, { isRootNav: false });
            return;
        }

        this.resultProvider.removeCongrat(this.result.id).then(() => {
            this.getFans();
            this.onToogleDOM();
            this.eventsListener.publish('toolbar:update');
        });
    }

    getFans() {
        let loader = this.loadingCtrl.create({ content: this.translate.instant('GLOBAL_LOADING') });
        loader.present();
        if (!this.result) {
            loader.dismiss();
            return;
        }
        this.resultProvider.getFans(this.result.id, this.pager.page, this.pager.start, this.pager.limit).then(data => {
            this.fans = data;
            console.log('fans: ', this.fans);
            for (let fan of this.fans) {
                if (fan.usrId == this.profile.id) {
                    this.themeMode==='darkMode'?this.state = "white": this.state = "gray";
                    this.onToogleDOM();
                }
            }
            loader.dismiss();
        }).catch(err => loader.dismiss());
    }

    getPrivateProfile(): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            this.userProvider.getPrivateProfile().then(profile => {
                this.profile = profile;
                resolve(true);
            }).catch(err => {
                console.log('err: ', err);
                resolve(false);
            });
        });
    }

    onFanDescription(fan) {
        this.toastCtrl.create({
            message: fan.userName,
            closeButtonText: 'OK',
            showCloseButton: true,
            position: 'bottom',
            duration: 5000
        }).present();
    }

    onFanPressed(isFirst: boolean) {
        console.log('isLast: ', isFirst);
        (isFirst) ? this.openEventDetails() : this.showSportProfile();
    }

    openEventDetails() {
        let loader = this.loadingCtrl.create({ content: this.translate.instant('GLOBAL_LOADING') });
        loader.present();

        this.eventService.getEventDetails(this.result.eventId).then((event: EventDetailsModel) => {
            (this.app.getRootNav() as NavController).push(EventTabsPage, { event: event }).then(() => loader.dismiss());
        });
    }

    showSportProfile() {
        let loader = this.loadingCtrl.create({ content: this.translate.instant('GLOBAL_LOADING') });
        loader.present();
    }

    ionViewWillEnter() {
        this.result = this.navParams.get("result");

        if (!this.sessionService.isLoged) { this.getFans(); return; }

        this.getPrivateProfile().then(value => {
            if (value) this.getFans();
        });
    }
}


// WEBPACK FOOTER //
// /src/pages/results/result-details/result-details-thumbup/result-details-thumbup.ts